/**
 * 本地确认所有的路由集合
 * 和用户真实权限对比输出当前用户权限
 * todo 产品过多后需要拆分出来方便查看
 * mate name 和后端传入的name 匹配 type 标记当前页面所属的产品类型
 *
 */
const allRouter:any = [
    {
        path: 'onepass',
        name: 'onepass',
        component: () => import('@/views/onepass/onepass.vue'),
        meta: { name: '本机号码校验', type: 'gateway' },
        children: [
            {
                path: 'setting',
                component: () => import('@/views/onepass/setting.vue'),
                name: 'onepass_setting',
                meta: { name: '应用配置', type: 'gateway' },
            },
            {
                path: 'report',
                component: () => import('@/views/onepass/report.vue'),
                name: 'onepass_report',
                meta: { name: '数据统计', type: 'gateway' },
            },
        ],
    },
    {
        path: 'onelogin',
        name: 'onelogin',
        component: () => import('@/views/onelogin/onelogin.vue'),
        meta: { name: '一键登录', type: 'gateway' },
        children: [
            {
                path: 'setting',
                component: () => import('@/views/onelogin/setting.vue'),
                name: 'onelogin_setting',
                meta: { name: '应用配置', type: 'gateway' },
            },
            {
                path: 'report',
                component: () => import('@/views/onelogin/report.vue'),
                name: 'onelogin_report',
                meta: { name: '数据统计', type: 'gateway' },
            },
        ],
    },
    {
        path: 'onepass_web',
        name: 'onepass_web',
        component: () => import('@/views/onepass_web/onepass_web.vue'),
        meta: { name: '本机号码认证H5', type: 'gateway' },
        children: [
            {
                path: 'setting',
                component: () => import('@/views/onepass_web/setting.vue'),
                name: 'onepass_web_setting',
                meta: { name: '应用配置', type: 'gateway' },
            },
            {
                path: 'report',
                component: () => import('@/views/onepass_web/report.vue'),
                name: 'onepass_web_report',
                meta: { name: '数据统计', type: 'gateway' },
            },
        ],
    },
    {
        path: 'onelogin_web',
        name: 'onelogin_web',
        component: () => import('@/views/onelogin_web/onelogin_web.vue'),
        meta: { name: '一键登录H5', type: 'gateway' },
        children: [
            {
                path: 'setting',
                component: () => import('@/views/onelogin_web/setting.vue'),
                name: 'onelogin_web_setting',
                meta: { name: '应用配置', type: 'gateway' },
            },
            {
                path: 'report',
                component: () => import('@/views/onelogin_web/report.vue'),
                name: 'onelogin_web_report',
                meta: { name: '数据统计', type: 'gateway' },
            },
        ],
    },
    {
        path: 'test',
        name: 'test',
        component: () => import('@/views/common.vue'),
        meta: { name: '测试', type: 'test' },
    },
];

const allProduct = ['gateway'];
export { allProduct, allRouter };
